<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import PiIcon from '@uiKit/elements/PiIcon.vue'
import Text from '@uiKit/elements/Text.vue'

// Shared chrome for the two money-moving dialogs. The kit `Dialog`'s built-in
// close icon is turned off in both so the header can own its own spacing and
// the round close affordance the design draws.
interface Props {
  title: string
  /** Blocks dismissal mid-submission so a request can't be orphaned. */
  disabled?: boolean
}

withDefaults(defineProps<Props>(), {
  disabled: false,
})

const emit = defineEmits<{
  (e: 'close'): void
}>()
</script>

<template>
  <Box align="center" justify="between" gap="3" class="mmh">
    <Text type="title-lg" is="h2">{{ title }}</Text>
    <Box
      is="button"
      flex
      align="center"
      justify="center"
      class="mmh__close"
      type="button"
      :disabled="disabled"
      aria-label="Close"
      @click="emit('close')"
    >
      <PiIcon name="times" class="mmh__close-icon" />
    </Box>
  </Box>
</template>

<style scoped>
.mmh {
  flex-shrink: 0;
  padding: 1.375rem 1.5rem 1.25rem 1.75rem;
}

.mmh__close {
  width: 32px;
  height: 32px;
  background: var(--p-surface-100);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  color: var(--p-text-muted-color);
  flex-shrink: 0;
  transition: background 0.15s;
}

.mmh__close:hover:not(:disabled) {
  background: var(--p-surface-200);
}

.mmh__close:focus-visible {
  outline: 2px solid var(--p-primary-600);
  outline-offset: 2px;
}

.mmh__close-icon {
  font-size: 14px;
}

@media (max-width: 992px) {
  .mmh {
    padding: 1rem 1rem 0.875rem;
  }
}
</style>
